import type { ReactNode } from 'react';

/**
 * Small stat block — label + big tabular-num value + optional hint.
 * Used on Reception ("On site 12/47"), Coordinator dashboards, the
 * /me self-service header. Designed to be laid out in grids of 2-4.
 *
 * Surfaces are consciously light: a thin border + small shadow so a
 * row of MetricBlocks doesn't pull focus from the surrounding cards.
 */
export function MetricBlock({
  label,
  value,
  hint,
  className = '',
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`rounded-token border border-line/10 bg-surface px-4 py-3 shadow-token-sm ${className}`}
    >
      <div className="text-[11px] font-semibold uppercase tracking-wider text-fg-dim">
        {label}
      </div>
      <div className="mt-1 text-2xl font-semibold tracking-tight tabular-nums text-fg">
        {value}
      </div>
      {hint ? (
        <div className="mt-0.5 text-xs text-fg-muted">{hint}</div>
      ) : null}
    </div>
  );
}
